import Image from 'next/image';
import tw from 'twin.macro';
import { useAtomValue } from 'jotai';
import { FlagIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

import { PresentationCard, ProgressBar, Title, getCountryFlagUrl } from '@restworld/ui-ds';

import { TabCardWrapper } from '../candidate-profile-section';
import { workerLanguagesAtom } from '../../../../employer-job-listing.atoms';

export const LanguageSection = () => {
  const workerLanguages = useAtomValue(workerLanguagesAtom);
  const { t } = useTranslation('onboarding-page');
  const errorMessage = t('missing_info');

  workerLanguages?.sort((a, b) => {
    const aLevel = a?.language_level_cefr_var?.order;
    const bLevel = b?.language_level_cefr_var?.order;
    return aLevel && bLevel ? bLevel - aLevel : 0;
  });
  return (
    <TabCardWrapper title={t('languages')}>
      <div id="languages" tw="flex flex-col items-start pt-4">
        <div tw="flex lg:flex-row flex-col lg:gap-12 gap-6 w-full">
          <div tw="flex flex-1 flex-col items-start gap-4">
            {workerLanguages?.map((language, index) => {
              const label = (
                <div tw="flex flex-row justify-between items-center w-full">
                  <Title variant="h6-large" textColor="gray-500" fontWeight="medium">
                    {language?.language_var?.label}
                  </Title>
                  <Title variant="h6-large" textColor="gray-500" fontWeight="normal">
                    {language?.language_level_cefr_var?.label}
                  </Title>
                </div>
              );
              const level = language?.language_level_cefr_var?.order;
              const percent = level ? (level / 6) * 100 : 0;
              return (
                <PresentationCard
                  key={index}
                  label={label}
                  header={level ? <ProgressBar percent={percent} /> : errorMessage}
                  icon={<CountryFlag countryShortKey={language?.language_var.key as keyof typeof countryShortKeyMap} />}
                  contentStyling={tw`gap-2`}
                />
              );
            })}
            {!workerLanguages?.length && (
              <Title fontWeight="normal" textColor="gray-500" variant="h6-large">
                {errorMessage}
              </Title>
            )}
          </div>
        </div>
      </div>
    </TabCardWrapper>
  );
};
const CountryFlag = ({ countryShortKey }: { countryShortKey?: keyof typeof countryShortKeyMap }) => {
  const countyImgUrl = countryShortKeyMap[countryShortKey];
  return countyImgUrl ? (
    <Image alt={countryShortKey} src={getCountryFlagUrl(countyImgUrl)} height={24} width={24} />
  ) : (
    <FlagIcon tw="w-6 h-6 text-primary-700" />
  );
};
const countryShortKeyMap = {
  russian: 'RU',
  english: 'GB',
  italian: 'IT',
  spanish: 'ES',
  french: 'FR',
  german: 'DE',
};
